import { Component, OnInit } from '@angular/core';
import { PopUpService } from 'core/services';
import { Popup } from '@models/popup';
@Component({
  selector: 'lms-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit {
  public popupState: Popup = {};

  constructor(public popupService: PopUpService) {}

  ngOnInit() {
    this.popupService.getPopupState$().subscribe((popupState: Popup) => {
      this.popupState = popupState;
    });
  }

  public onClose() {
    this.popupService.closePopup(this.popupState.callbackToClose || null);
  }
}
